import {IPromise, IQService} from "angular";
import {regNavn} from "../tredjepartsTjenestenavn";
import {l} from "types/typescriptdefinisjoner_lederplan";

export class RessursPromisHjelp {

    static regNavn = "RessursPromisHjelp";

    static forInjisering() {
        return [
            regNavn.ng.$q,
            RessursPromisHjelp
        ];
    }

    constructor(private $q: IQService) {
    }

    //offentlige metoder

    somPromise<T>(ressursEllerObjekt: l.AngularRessurs<T>|T) :IPromise<T>{
        return this.$q.when((<any>ressursEllerObjekt).$promise || ressursEllerObjekt);
    }
}
